import React from 'react';
import { useSelector } from 'react-redux';

import HeartImage from '../../assets/images/death_reasons/heartImage';
import HeartEng from '../../assets/images/death_reasons/heartEng';
import HeartRus from '../../assets/images/death_reasons/heartRus';
import Border from '../../assets/images/border';

import './heart.scss';

const Heart = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='heart'>
            <Border />
            {language === 'ENG' ? <HeartEng /> : <HeartRus />}
            <HeartImage />
            <span className='heart-text'>
                {language === 'RUS' ? 'Высокий риск сердечно-сосудистых проблем означает повышенную вероятность тяжёлых осложнений, которые могут существенно снизить ожидаемую продолжительность жизни без своевременной профилактики.' : 'High risk of heart-related problems indicates a higher probability of severe complications, which can significantly reduce life expectancy without timely prevention.'}
            </span>
        </div>
    );
};

export default Heart;